import { invalidateQuery } from './createApiQueryOptions';
import { setMethodMutableOverride } from '../../apis-infra/utils/internal';
const isDeepStrictEqual = (val1, val2) => {
  const isArrays = Array.isArray(val1) && Array.isArray(val2);
  const isObjects = typeof val1 === 'object' && typeof val2 === 'object';
  if (isArrays) {
    return val1.length === val2.length && val1.every((v, i) => isDeepStrictEqual(v, val2[i]));
  }
  if (isObjects) {
    const val2Entries = Object.entries(val2);
    const val1Entries = Object.entries(val1);
    return val1Entries.length === val2Entries.length && val1Entries.every((_ref, i) => {
      let [k, v] = _ref;
      return k === val2Entries[i][0] && isDeepStrictEqual(v, val2Entries[i][1]);
    });
  }
  return val1 === val2;
};

/** *
 * this invalidates the method query as will cause refetch, handle with care!
 */
export function setMethodOverride(methodConfig, override, refetch) {
  const prevValue = methodConfig._mutableOverride;
  setMethodMutableOverride(methodConfig, override);
  if (refetch && !isDeepStrictEqual(prevValue, override)) {
    invalidateQuery(methodConfig);
  }
  return prevValue;
}
export function mergeQueryOptions() {
  for (var _len = arguments.length, options = new Array(_len), _key = 0; _key < _len; _key++) {
    options[_key] = arguments[_key];
  }
  const final = options.reduce((acc, opt) => {
    var _opt$meta$groupId, _opt$meta, _acc$meta, _acc$meta$tags, _acc$meta2, _opt$meta$tags, _opt$meta2;
    return {
      ...acc,
      ...opt,
      meta: {
        ...(acc == null ? void 0 : acc.meta),
        ...(opt == null ? void 0 : opt.meta),
        groupId: (_opt$meta$groupId = opt == null ? void 0 : (_opt$meta = opt.meta) == null ? void 0 : _opt$meta.groupId) != null ? _opt$meta$groupId : acc == null ? void 0 : (_acc$meta = acc.meta) == null ? void 0 : _acc$meta.groupId,
        tags: [...((_acc$meta$tags = acc == null ? void 0 : (_acc$meta2 = acc.meta) == null ? void 0 : _acc$meta2.tags) != null ? _acc$meta$tags : []), ...((_opt$meta$tags = opt == null ? void 0 : (_opt$meta2 = opt.meta) == null ? void 0 : _opt$meta2.tags) != null ? _opt$meta$tags : [])]
      }
    };
  }, {});
  return final;
}
//# sourceMappingURL=internal.js.map